import { render } from "./payment3.vue?vue&type=template&id=724b6f29&scoped=true"
import script from "./payment3.vue?vue&type=script&lang=js"
export * from "./payment3.vue?vue&type=script&lang=js"

import "./payment3.vue?vue&type=style&index=0&id=724b6f29&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724b6f29"]])

export default __exports__